<div class="first-video-wrapper">
    <div class="second-video-wrapper">
        <span style="display: block;padding-top: 57%"></span>
        <iframe [src]="getVideoUrl(shenase)" allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
    </div>
</div>